var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"left-sidebar"},[_c('perfect-scrollbar',{staticClass:"scroll-sidebar"},[_c('nav',{staticClass:"sidebar-nav"},[_c('bo-sidebar-menu',{attrs:{"items":_vm.navigation}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }